import React from "react";
import {Box, Paper, Card, CardHeader} from "@mui/material";

import SlidingSessionCard from "./SlidingSessionCard";
import {useSessionPolling} from "../../../hooks/useSessionPolling";
import {NO_UPCOMING_SESSIONS_MESSAGE} from "../../../helpers/SessionHelper";

const styles = {
    container: {
        cards: {
            alignItems: "flex-start",
            display: "flex",
            gap: "1.5rem"
        }
    },
    card: {
        elevation: 12,
        wrapper: {
            flexShrink: 0
        }
    },
    emptyState: {
        p: 5,
        backgroundColor: '#f2f8ff'
    }
};

export default function SlidingTimeslotPanel({timeslotEvents, timeslots, selectedSession, selectedSessionServiceTypeDetails, onCardClose, onPdfClick, onExpandContent}) {

    const {time, upcomingSessions} = useSessionPolling(timeslotEvents, timeslots);
    const isSelectedSessionInUpcomingList = selectedSession && upcomingSessions?.some(session => session.id === selectedSession.id);

    const hasNoSessions = (!upcomingSessions || upcomingSessions.length === 0) && !selectedSession;

    if (hasNoSessions) {
        return (
            <Card sx={styles.emptyState}>
                <CardHeader title={NO_UPCOMING_SESSIONS_MESSAGE}/>
            </Card>
        );
    }

    return (
        <Box sx={styles.container.cards}>
            {
                upcomingSessions?.map((upcomingSession) => (
                  <Box key={upcomingSession.id} sx={styles.card.wrapper}>
                      <Paper elevation={styles.card.elevation}>
                          <SlidingSessionCard
                            selectedEvent={upcomingSession}
                            serviceTypeDetails={{
                                type: upcomingSession.type,
                                color: upcomingSession.color
                            }}
                            currentTime={time}
                            onPdfClick={onPdfClick}
                            onExpandContent={onExpandContent}
                          />
                      </Paper>
                  </Box>
                ))
            }
            {
              selectedSession
              &&
              !isSelectedSessionInUpcomingList
              &&
              (
                <Box key={selectedSession.id} sx={styles.card.wrapper}>
                    <Paper elevation={styles.card.elevation}>
                        <SlidingSessionCard
                          selectedEvent={selectedSession}
                          serviceTypeDetails={selectedSessionServiceTypeDetails}
                          currentTime={time}
                          onCardClose={onCardClose}
                          onPdfClick={onPdfClick}
                          onExpandContent={onExpandContent}
                          isSelected={true}
                        />
                    </Paper>
                </Box>
              )
            }
        </Box>
    );
}
